import type {
  LoginResponse,
  LatestResponse,
  ListResponse,
  ChartResponse,
} from '@/types/api';

const BASE_URL = 'https://tof.eemo.co.kr/api';

async function fetchApi<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export const cropApi = {
  /**
   * 로그인 - device_id 유효성 확인
   * GET /api/api_login.php?device_id=GF-CROP-001
   */
  login: (deviceId: string): Promise<LoginResponse> =>
    fetchApi<LoginResponse>(
      `${BASE_URL}/api_login.php?device_id=${encodeURIComponent(deviceId)}`
    ),

  /**
   * 최신 촬영 데이터 1건 조회
   * GET /api/api_latest.php?device_id=GF-CROP-001
   */
  getLatest: (deviceId: string): Promise<LatestResponse> =>
    fetchApi<LatestResponse>(
      `${BASE_URL}/api_latest.php?device_id=${encodeURIComponent(deviceId)}`
    ),

  /**
   * 히스토리 목록 조회 (페이징 + 날짜 필터)
   * GET /api/api_list.php?device_id=GF-CROP-001&page=1&limit=20&sdate=2026-04-16&edate=2026-04-18
   */
  getList: (
    deviceId: string,
    page: number,
    limit: number,
    sdate?: string,
    edate?: string
  ): Promise<ListResponse> => {
    let url = `${BASE_URL}/api_list.php?device_id=${encodeURIComponent(deviceId)}&page=${page}&limit=${limit}`;
    if (sdate) url += `&sdate=${encodeURIComponent(sdate)}`;
    if (edate) url += `&edate=${encodeURIComponent(edate)}`;
    return fetchApi<ListResponse>(url);
  },

  /**
   * 차트용 데이터 조회 (최근 N건)
   * GET /api/api_chart.php?device_id=GF-CROP-001&cnt=30
   */
  getChart: (deviceId: string, cnt = 30): Promise<ChartResponse> =>
    fetchApi<ChartResponse>(
      `${BASE_URL}/api_chart.php?device_id=${encodeURIComponent(deviceId)}&cnt=${cnt}`
    ),
};
